<template>
    <div class="s-nice-text" v-if="topicCategory">
        <div class="o-layout  o-layout--right">
            <div class="o-layout__item  u-4/12  u-12/12@sm" v-if="topicCategory.image">
                <img :src="$root.pUrl + topicCategory.image" alt=""
                     class="u-12/12  u-margin-bottom"
                     v-if="topicCategory.image">
            </div>
            <div class="o-layout__item  u-8/12  u-12/12@sm">
                <h2>{{ topicCategory.name }}</h2>
                <div v-html="topicCategory.description.replace(/\n/g, '<br>')" v-if="topicCategory.description"></div>
            </div>
        </div>

        <div class="o-layout  o-layout--right" v-if="topicCategory.topics.length > 0">
            <div class="o-layout__item  u-8/12  u-12/12@md">
                <p>주제를 클릭하면 주제 소개를 볼 수 있습니다.</p>
            </div>
            <div class="o-layout__item  u-10/12  u-12/12@md">
                <div class="c-separator  c-separator--nice  u-margin-bottom  u-padding-top"></div>
            </div>
        </div>

        <div class="o-layout  o-layout--right" v-if="topicCategory.topics.length > 0">
            <div class="o-layout__item  u-8/12  u-9/12@md  u-12/12@sm">
                <ul>
                    <li v-for="topic of topicCategory.topics">
                        <div class="s-nice-text__normal">
                            <topic-title :topic="topic" :isLink="!!topic.introLong"/>

                            <p class="s-nice-text__small  c-minus-intent-large  u-text-keep-words"
                               v-for="profile of topic.profiles" v-if="topic.profiles.length">
                                <span class="u-text-bold">{{ profile.name }}</span>
                                {{ profile.introShort }}
                            </p>
                        </div>
                        <p v-if="showTopicMeta(topic)">
                            <span v-if="topic.hideTime === 'n'">
                                {{ readableTime(topic.startTime) }} - {{ justTime(topic.endTime) }}
                            </span>
                            <span class="c-nice-pipe-symbol"
                                  v-if="topic.hideLocation === 'n' && topic.location"></span>
                            {{ topic.location }}
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "TopicCategory",
		props: ["topicCategory", 'marxism'],
		mixins: [require('./mixin')],
		methods: {
			readableTime(hh_mm) {
				if (moment(hh_mm, 'hh:mm').format('m') === '0') {
					return moment(hh_mm, 'hh:mm').format('a h시');
				} else {
					return moment(hh_mm, 'hh:mm').format('a h시 m분');
				}

			},
			justTime(hh_mm) {
				if (moment(hh_mm, 'hh_mm').format('m') === '0') {
					return moment(hh_mm, 'hh:mm').format('h시');
				} else {
					return moment(hh_mm, 'hh:mm').format('h시 m분');
				}
			}

		},
		mounted() {
			let pageTitle = this.topicCategory.name;
			document.querySelector('title').innerText = `${pageTitle} | ${marxism.title} - 마르크스주의 포럼`;

			if (window.gtag) {
				if (window.gtag) {
					// for google analytics page tracking
					window.gtag('config', 'UA-2193909-1', {
						'page_title': `${pageTitle} | ${this.marxism.title} - 마르크스주의 포럼`,
						'page_path': (new URL(location.href)).pathname
					});
				}
			}
		}
	}
</script>

<style scoped>

</style>
